import React from "react";
import ScoollTableIpad from "./ScoollTableIpad";
import { ProductConsumer } from "../../../../Context/AddProWakel";

const AddCinLeft = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          return (
            <>
              <div className="mt5">
                <h1
                  className="tc border p-2 mx-5 border-warning  text-warning"
                  style={{ backgroundColor: "#2C3539" }}
                >
                  کاتی گەیشتنی شتەکان
                </h1>
              </div>
              <ScoollTableIpad />
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default AddCinLeft;
